module.exports = __webpack_public_path__ + "media/smile-5.f24a0b21.mp3";